module.exports = __webpack_public_path__ + "static/img/69.3f6ef5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/69.png
// module id = XOhn
// module chunks = 1